<template>
  <div class="mfp-with-anim mfp-hide mfp-dialog clearfix" id="nav-pwd-dialog">
    <h3 class="widget-title">Password Recovery</h3>
    <p>Enter Your Email and We Will Send the Instructions</p>
    <hr />
    <form>
      <div class="form-group">
        <label>
          Your Email
          <!-- {{passwordRecoveryDetails}} -->
        </label>
        <input class="form-control" v-model="email" type="text" />
      </div>
      <div v-if="error != ''" class="alert alert-danger">
        <label>{{error}}</label>
      </div>
      <!-- <input class="btn btn-primary" type="submit" value="Recover Password" /> -->
      <!-- <input class="btn btn-primary" @click.stop="onSubmit" readonly value="@btnName" /> -->
      <button class="btn btn-primary" type="button" @click.stop="onSubmit" readonly>{{btnName}}</button>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import eventBus from "@/lib/eventBus";

export default {
  data() {
    return {
      email: "",
      error: "",
      btnName: "Recover Password"
    };
  },
  computed: {
    ...mapState("user", ["passwordRecoveryDetails"])
  },
  methods: {
     validateEmail(email) {
    //console.log('validateEmail ::::::::::::::: ', email);
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //console.log('validateEmail return ::::::::::::::: ', re.test(email));
    return re.test(email);
    },
    async onSubmit() {
      if (this.email == "" || this.email == null) {
        this.error = "Email is empty";
        return;
      }
      else if (this.validateEmail(this.email) == false) {
        //console.log('validateEmail not valid ::::::::::::::: ', this.validateEmail(this.emailNewsletter));
        this.error = "Email is not valid";
        return;
      }

      this.error = "";
      this.btnName = "Please Wait...";
      //console.log("this.email ::::::::::: ", this.email);

      await this.$store.dispatch("user/passwordRecovery", {
        email: this.email
      });

      //   console.log(
      //     "this.passwordRecoveryDetails ::::::::::: ",
      //     this.passwordRecoveryDetails
      //   );

      if (this.passwordRecoveryDetails.ReturnCode != 401) {
        
        this.$alert(
          this.passwordRecoveryDetails.ResponseMessage,
          "success"
        ).then(() => {
          this.btnName = "Recover Password";
          this.email = "";
          $.magnificPopup.open({
            items: {
              src: "#nav-login-dialog"
            },
            type: "inline"
          });
        });

      } else {
        this.btnName = "Recover Password";
        this.error = this.passwordRecoveryDetails.ResponseMessage;
      }

      /*

      
      eventBus.$emit('user.registered', this.email);
      this.error == ''
      this.password = '';
      this.confirmPassword = '';
      this.name = '';
      this.mobile = '';
      this.email = '';


      $.magnificPopup.open({
        items: {
            src: '#nav-login-dialog',
        },
        type: 'inline'
      });
      */
    }
  }
};
</script>

